import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {toast} from "react-toastify"

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import { FaRegEye, FaRegEyeSlash  } from "react-icons/fa6";
import { isEmpty } from "../helper/common";
import { userLogin } from "../Axios/user.axios";
import config from '../helper/config';
import Subscriber from "../Layout/subscribe";

const initform = {
    Password: '',
    ConfirmPassword: '',
};

const initname = {
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
}

export default function Forgot() {

    
    const location = useLocation();
    const navigate = useNavigate()
    
    
    const [passwordType, setPasswordType] = useState("password");
    const [passwordType1, setPasswordType1] = useState("password");
    const [currtoken,SetCurrtoken] = useState('');
    const [focusedfield,SetFocusedField] = useState([]);

    const [formdata, SetFormdata] = useState(initform);
    const [displayname, SetDisplayName] = useState(initname);
    const [Error, SetError] = useState({});

    

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const togglePassword1 = () => {
        if (passwordType1 === "password") {
          setPasswordType1("text")
          return;
        }
        setPasswordType1("password")
    }

    useEffect(() => {
        
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    useEffect(()=>{
        let changetoken = location?.search?.split("?id=")?.[1];
        if(!isEmpty(changetoken)){
            SetCurrtoken(changetoken);
        }
    },[location?.search])

    const OnChange = (e) => {
        const { id, value } = e.target;
        // SetError({})
        SetFormdata({ ...formdata, ...{ [id]: value } });
    }

    const Validate = () => {
        let error = {};
        (Object.keys(formdata)).map((val) => {
            if (isEmpty(formdata[val])) {
                error[val] = "Enter " + displayname[val];
            }
            else {
                if (val == 'Password') {
                    if (!config.PASSWORD.test(formdata[val])) {
                        error[val] = "Password must contain alphanumeric, must contain 8 to 15 letters.";
                    }
                }
                else if (val == 'ConfirmPassword' && formdata?.ConfirmPassword != formdata?.Password) {
                    error[val] = "Password and Confirm Password Must be Same.";
                }
            }
        })
        return error
    }

    const ChangePassword = async () => {
        let error = Validate();
        if (isEmpty(error)) {
            let senddata = formdata;
            senddata.Type = "resetpassword";
            senddata.resettoken = currtoken;
            var Resp = await userLogin(senddata);
            console.log('userLogin_resp', Resp)
            if (Resp?.success == 'success') {
                toast.success(Resp.msg, 1000)
                navigate('/profile')
            }
            else {
                toast.error(Resp.msg, 1000);
            }
        }
        else {
            SetError(error);
            toast("Fill the Correct datas", { type: 'error' })
        }
    }

    const OnBlurFn = (e) => {
        const { id, value } = e.target;
        let error = Validate();
        Object.keys(error).map((currkey)=>{
            if(currkey==id||focusedfield.includes(currkey)){
            }
            else{
                delete error[currkey];
            }
        })
        if(focusedfield?.includes(id)){
        }
        else{
            SetFocusedField([
                ...focusedfield,
                ...[id],
            ])
        }
        SetError(error);
    }

    return (

        <>

            <div className="forgotpage">

                <Header />

                <section class="section">
                    <div className="container font-md">
                        <div className="container text-center customer-reset-password">
                            <h2 className="color-brand-1 mb-4">Change Password</h2>

                            <form method="POST" class="row" action="">
                                <div className="col-lg-12 col-sm-12 mb-4">
                                    <div className="form-group position-relative">
                                        <input className={focusedfield?.includes('Password') ? (Error?.Password ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"} placeholder="New Password"  type={passwordType} value={formdata?.Password||''} aria-required="true" id='Password' onChange={(e)=>OnChange(e)} onBlur={(e)=>OnBlurFn(e)}/>
                                        <div onClick={togglePassword}>
                                            {passwordType == "text" ? <FaRegEye className="eyepassword" /> :
                                                <FaRegEyeSlash className="eyepassword" />}</div>
                                    </div>
                                    {Error?.Password && <p className="error-msg text-left">{Error.Password}</p>}
                                </div>
                                <div className="col-lg-12 col-sm-12 mb-4">
                                    <div className="form-group position-relative">
                                        <input className={focusedfield?.includes('ConfirmPassword') ? (Error?.ConfirmPassword ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"} placeholder="Confirm Password" type={passwordType1} value={formdata?.ConfirmPassword||''} aria-required="true" id='ConfirmPassword' onChange={(e)=>OnChange(e)} onBlur={(e)=>OnBlurFn(e)}/>
                                        <div onClick={togglePassword1}>
                                            {passwordType1 == "text" ? <FaRegEye className="eyepassword" /> :
                                                <FaRegEyeSlash className="eyepassword" />}</div>
                                    </div>
                                    {Error?.ConfirmPassword && <p className="error-msg text-start">{Error.ConfirmPassword}</p>}
                                </div>
                                <div class="col-lg-12 mb-5">
                                    <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={()=>ChangePassword()}>Change Password</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>

                <Subscriber/>
                {/* <div className="box-newsletter">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 mt-3 col-md-12">
                                <div className="box-image-newsletter">
                                    <div className="">
                                        <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                                        <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-3">
                                <span className="font-lg color-brand-1">Newsletter</span>
                                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                                <div className="form-newsletter mt-3 position-relative">
                                    <form action="" className="newsletter-form" novalidate="novalidate">
                                        <input type="email" name="email" placeholder="Enter your email..." />
                                        <button className="btn btn-submit-newsletter" type="submit">
                                            <FaArrowRight />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <Footer />

            </div>

        </>
    );
}
